import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const BeginnerTrainingProgram = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Beginner Training Program</h2>
                            <p>
                                The Beginner Training Program at Net Nest Badminton Sports Club is specially designed for players who are new to badminton or have very little playing experience. This program focuses on building a strong foundation by teaching the basics of the game in a simple, structured, and supportive environment.
                            </p>
                            <h2>Program Overview</h2>
                            <p>
                                Our beginner program introduces players to badminton in a fun and confidence-building way. The training is carefully planned to help players understand the fundamentals while enjoying the learning process. It creates the right base for future skill development and advanced training.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Beginner Training Program (1).jpg" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Fundamentals of Badminton</h2>
                            <p>
                                Correct grip techniques (forehand and backhand)
                                <br></br>
                                Proper stance and body positioning
                                <br></br>
                                Basic strokes such as clear, drop, lift, and net shots
                                <br></br>
                                Introduction to smash technique
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Footwork & Movement Training</h2>
                            <p>
                                Basic court movement patterns
                                <br></br>
                                Balance and coordination exercises
                                <br></br>
                                Simple footwork drills to improve agility
                                <br></br>
                                Proper recovery positions after shots
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Rules & Game Understanding</h2>
                            <p>
                                Basic rules and scoring system
                                <br></br>
                                Court markings and positioning
                                <br></br>
                                Singles and doubles game format
                                <br></br>
                                Match etiquette and fair play
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Fitness & Physical Development</h2>
                            <p>
                                Improving stamina and flexibility
                                <br></br>
                                Developing hand-eye coordination
                                <br></br>
                                Enhancing basic strength and endurance
                                <br></br>
                                Preventing injuries through proper warm-up routines
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Friendly & Supportive Coaching Environment</h2>
                            <p>
                                Individual attention in small groups
                                <br></br>
                                Encouragement and positive motivation
                                <br></br>
                                Step-by-step learning without pressure
                                <br></br>
                                A safe and enjoyable training atmosphere
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Gradual Match Introduction</h2>
                            <p>
                                Simple rally play
                                <br></br>
                                Practice matches
                                <br></br>
                                Friendly internal games
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Suitable for All Age Groups</h2>
                            <p>
                                Children starting badminton for the first time
                                <br></br>
                                Teenagers exploring a new sport
                                <br></br>
                                Adults and working professionals learning badminton
                                <br></br>
                                Recreational players seeking structured coaching
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BeginnerTrainingProgram;